import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { VariableSizeList as List } from 'react-window';

const taxonomyMenuListRef = React.createRef();

const UploadFileTaxonomyMenuList = ({
  options,
  children,
  getValue,
}) => {
  useEffect(() => {
    if (children && children.length) {
      const focused = children.findIndex(c => (c.props.isFocused));
      if (taxonomyMenuListRef.current && focused) {
        taxonomyMenuListRef.current.scrollToItem(focused);
      }
    }
  });

  const ch = children.length ? children : [children];
  const [value] = getValue();
  const initialOffset = options.indexOf(value) * 40;
  const totalHeight = ch.length ? ch.length * 42 : 42;

  return (
    <List
      ref={taxonomyMenuListRef}
      height={Math.min(totalHeight, 300)}
      itemCount={ch.length}
      itemSize={() => 40}
      initialScrollOffset={initialOffset}
    >
      {({ index, style }) => <div style={style}>{ch[index]}</div>}
    </List>
  );
};

UploadFileTaxonomyMenuList.propTypes = {
  options: PropTypes.array.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  getValue: PropTypes.func.isRequired,
};

export default UploadFileTaxonomyMenuList;
